import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isNumeric } from '../_helpers';
import { connect } from 'react-redux';
import ComponentRouter from './ComponentRouter';
import { styles } from '../constants';

import { View, Button, Text, Icon } from 'native-base';
// import { Text } from 'react-native';

import BlockText from './BlockText';
import BlockButton from './BlockButton';
import BlockSubTitle from './BlockSubTitle';
import {getBlockByUrl, setAlert, updateUserData, goBack} from "../actions";
import {Animated} from 'react-native';

let timer = () => { };
let relaxTimer = () => { };


const TimeIcon = () => <Icon name="ios-time" style={{ color: 'rgba(226, 5, 28, 0.22)' }} />;

const IndicatorItem = (props) => {
  const { itemResult } = props;
  return (
    itemResult ?
      <View style={[styles.indicatorItem, styles.indicatorItemActive]}>
        <Text style={styles.indicatorText}>{itemResult}</Text>
      </View> :
      <View style={styles.indicatorItem}>
        <TimeIcon />
      </View>
  );
};

const Indicator = (props) => {
  const { testResult } = props;
  
  return (
    <View style={styles.indicatorHolder}>
      <IndicatorItem itemResult={testResult[0]} />
      <IndicatorItem itemResult={testResult[1]} />
      <IndicatorItem itemResult={testResult[2]} />
    </View>
  );
};

const Counter = (props) => {
  return (
    <View style={styles.counterHolder}>
      {props.digit ? <Text style={styles.counterText}>{props.digit}</Text> : <TimeIcon />}
    </View>
  );
};

const RelaxCounter = (props) => {
  return (
    <View style={styles.counterHolder}>
      {props.digit ? <Text style={styles.counterRelaxText}>{props.digit}</Text> : <TimeIcon />}
    </View>
  );
};


class BreathTest extends Component {
  constructor() {
    super();
    this.state = {
      TEXT: { doBreath: {} , notReleaseButton: {}},
      time: 0,
      relaxTime: 15,
      step: 1,
      status: 'process',
      testResult: [],
      finish: 0,
    };
    this.Animation = new Animated.Value(0);
  }

    

  relax = () => {
    this.setState({ relaxTime: 15 }); // Время перерыва между подходами в тесте
    // this.setState({ relaxTime: 15 });
    clearInterval(relaxTimer);

    relaxTimer = setInterval(() => {
      const { testResult, time } = this.state;
      if (testResult[0]  >= 50 || testResult[1]  >= 50 || testResult[2] >= 50) {
        this.setState({
          time: 0,
          testResult: [...testResult, ''+time],
          status: "finished"
        });
      } else  {
      if (!this.state.relaxTime) {
        clearInterval(relaxTimer);
        this.setState({
          status: 'process'
        });
        return false;
      }
      this.setState(prevState => {
        return { relaxTime: prevState.relaxTime - 1 };
      });
    }
    }, 1000);
  }

  handlerPressIn = () => {
    this.setState({ time: 0 });
    clearInterval(timer);

    timer = setInterval(() => {
      this.setState(prevState => {
        return { time: prevState.time + 1 };
      });
    }, 1000);
  }

  handlerPressOut = () => {
    const { testResult, time, step } = this.state;
    clearInterval(timer);

    if (time) {
     
      if (step > 2) {
        this.setState({
          time: 0,
          testResult: [...testResult, ''+time],
          status: "finished"
        });
      } else {
        this.setState({
          time: 0,
          testResult: [...testResult, ''+time],
          step: Math.min(step + 1, 3),
          status: "relax"
        }, this.relax);
      }
    }
  }

  componentDidMount() {
    const { userData } = this.props;
    const { TEXT } = this.state;
    let allTexts = [];

    const searchInBlocks = (blocks) => {
      blocks.map(block => {
        block.elements.map(element => {
          allTexts[element.edgeID] = element.label;
          if (element.blocks && element.blocks.length > 0) {
            searchInBlocks(element.blocks);
          }
        });
      });
    };

    searchInBlocks(userData.blocks);
    // console.log(allTexts);

    /**
     * HARDCODE!
     */

    const mainText = allTexts[860001174]; // Пройдите тест на задержку дыхания, это поможет определить состояние Вашей дыхательной системы
    const holdButton = userData.lang === "ru" ? "Нажмите и удержите дыхание" : "press and hold"; // Нажмите и удержите дыхание // !!!Это пока не приходит
    const doBreath = {
      "1": allTexts[860001189], // Сделайте вдох -> выдох -> глубокий вдох, после чего задержите дыхание на столько на сколько вы максимально сможете
      "2": allTexts[860001196], // Еще раз - глубокий вдох, после чего задержите дыхание на столько на сколько вы максимально сможете
      "3": allTexts[860001207] // Последняя попытка - глубокий вдох, после чего задержите дыхание на столько на сколько вы максимально сможете
    };
    const notReleaseButton = {
      "1": allTexts[860001200], // Не отпускайте кнопку пока задерживаете дыхание!
      "2": allTexts[860001201], // Не отпускайте кнопку пока задерживаете дыхание!
      "3": allTexts[860001210] // Не отпускайте кнопку пока задерживаете дыхание!
    };
    const relaxMessage = allTexts[860001204]; // Пока идет обратный отсчет постарайтесь восстановить дыхание, дышите глубоко и чаще
    const endMessage = allTexts[860001353]; // Тест на задержку дыхания пройден, для получения результата пройдите далее

    // <== HARDCODE!


    this.setState({
      TEXT: {
        ...TEXT,
        doBreath,
        mainText,
        notReleaseButton,
        holdButton,
        relaxMessage,
        endMessage
      }
    });
    this.StartBackgroundColorAnimation();
  }

  // handlerPressIn = () => {
  //   console.log('handlerPressIn');
  // }

  // handlerPressOut = () => {
  //   console.log('handlerPressOut');
  // }


    //////////////////////adgem
    backAction = () => {
      const { dispatch, history } = this.props;
  
      if (history.length > 1) {
        dispatch(goBack());
      } //else {
      //   Alert.alert("", "Закрыть приложение?", [
      //     {
      //       text: "Отмена",
      //       onPress: () => null,
      //       style: "cancel"
      //     },
      //     {
      //       text: "Закрыть",
      //       onPress: () => BackHandler.exitApp()
      //     }
      //   ]);
      // }
  
      return true;
    };
  //////////////////////adgem
  handlerChange = (element) => {
  // handlerChange = (newValue, element) => {
  //   console.log('handlerChange');
  //   console.log('element: ', element);
    // console.log('this.state.testResult: ', this.state.testResult);
    // return false;
    let { block, dispatch } = this.props;
    // let { block, onChange, value } = this.props;
    // console.log('block: ', block);
    // console.log('BreathTest onChange: ', onChange);

    const name = '14=>250042856';
    // const name = element.block.name || '';
    const value = this.state.testResult;
    dispatch(updateUserData({ name, value }));

    // onChange && onChange({
    //   block,
    //   element,
    //   value: this.state.testResult
    // });

    if (element && element.blocks && element.blocks.length) {
      this.setState({ visible: !this.state.visible });
    }
    const action = element.element.action || {};
    // const { dispatch } = this.props;
    if (action.url) {
      dispatch(getBlockByUrl(action.url));
    } else {
      this.backAction();
      // dispatch(setAlert([{ 'message': 'Не указан путь запроса' }]));
    }

  }
  StartBackgroundColorAnimation = () =>
  {
    this.Animation.setValue(0);

    Animated.timing(
        this.Animation,
        {
          toValue: 1,
          duration: 2000
        }
    ).start(() => { this.StartBackgroundColorAnimation() });
  }

  render() {
    const { TEXT, time, relaxTime, testResult, step, status } = this.state;
    const { userData } = this.props;
    const { blocks } = userData;
    const blockButton = blocks.find(block => block.type === "BUTTON");
    // const mainText = mainTextBlock.elements[0].label;
    // console.log("BreathTest userData: ", userData);
    // console.log("BreathTest blocks: ", blocks);
    // console.log("BreathTest blockButton: ", blockButton);
    const backgroundColorConfig = this.Animation.interpolate(
        {
          inputRange: [ 0, 0.5, 1 ],

          outputRange: [ '#e2051c', '#ed9099', '#e2051c' ]

        });
    // console.log("backgroundColorConfig: ", backgroundColorConfig);
    return (
      <><View style={styles.container}>
        <BlockText block={{
          elements: [{
            label: TEXT.mainText
          }]
        }} />

        <Indicator testResult={testResult} />

        <Text style={styles.messageBlock}>
          {status === "process" ? TEXT.doBreath[step] : null}
          {status === "relax" ? TEXT.relaxMessage : null}
          {status === "finished" ? TEXT.endMessage : null}
        </Text>

        {status === "process" ? <Counter digit={time} /> : null}
        {status === "relax" ? <RelaxCounter digit={relaxTime} /> : null}

        <Text style={styles.messageHoldButton}>
          {status === "process" ? TEXT.notReleaseButton[step] : null}
        </Text>
      </View>

        <View style={styles.containerButton}>
          {status === "process" ?
              <Animated.View
                  style={{backgroundColor:backgroundColorConfig, borderRadius: 25}}
                  >
                <Button
            block
            id={"breath_button"}
            style={styles.animatedButton}
            // style={{backdropColor: '#ffffff00'}}
            onPressIn={this.handlerPressIn}
            onPressOut={this.handlerPressOut}
          >
            <Text style={styles.buttonText}>{TEXT.holdButton}</Text>
          </Button>
              </Animated.View>: null}

          {status === "finished" ? <BlockButton visible={true} block={blockButton} disabled={false} onChange={this.handlerChange} value={this.state.testResult}/> : null}

        </View>
        {status === "finished" ? null
            : <View style={styles.containerButton}>
              <BlockButton visible={true} block={blockButton} disabled={false} onChange={this.handlerChange}
                           value={this.state.testResult} skipButton={true}/>
            </View>
        }
      </>
    );
  }
}

BreathTest.propTypes = {
  userData: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.any
};

function mapStateToProps(state) {
  return {
    userData: state.userData,
    history: state.history,
    alerts: state.alerts,
    currentAction: state.currentAction
  };
}


export default connect(mapStateToProps)(BreathTest);
